import type { AuthenticatedUser } from '@/shared/types/payload.type.ts';
import type { AuthUser } from '@/shared/types/auth.type.ts';

export const toAuthenticatedUser = (user: AuthUser): AuthenticatedUser => {
  return {
    id: user.id,
    email: user.email,
    userType: user.userType,
    userRole: user.userRole,
    status: user.status,
  }
}